module.exports = __webpack_public_path__ + "img/logo.3b20d046.png";